import React, { ReactNode } from 'react';
import List from '../../atoms/Menu/List';
import type { IListElement } from '../../types/IListElement';

/** Подпись группы внутри экрана меню профиля (не пункт списка). */
export const UserMenuCaption: React.FC<{ children: ReactNode }> = ({ children }) => (
    <div className="rf-user-menu-dialog__caption">{children}</div>
);

/** Разделитель блоков меню профиля — во всю ширину панели. */
export const UserMenuSeparator: React.FC = () => <div className="rf-list__separator rf-anchored-dialog__separator" />;

/** Пункты-переходы меню профиля (`userMenuItem`): иконка 24px и подпись в строку 16/24. */
export const UserMenuList: React.FC<{ items: IListElement[] }> = ({ items }) => (
    <List list={items} className="rf-anchored-list-dialog__list rf-user-menu-dialog__list" />
);
